export default {
    slug: 'bo/objects',
    title: 'Bookable Objects',
    visible: [
        'label',
        'uuid'
    ],
    listview: 'ObjectsListView',
    locales: ['common'],
    columns: [
        {
            key: 'label',
            label: 'Label',
            main: true,
        }
    ],
    actions: {
        create: {
            title: 'Add new',
            level: 'highlight',
            icon: 'plus-circle',
            vm: 'addNew'
        },
        details: {
            title: 'Details',
            class: 'btn btn-default',
            level: 'row',
            vm: 'goToDetails'
        }
    },
    copyColumns: [
        'uuid'
    ],
    tooltipColumns: [
        'uuid'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/bookable-objects/objects/state.js